import * as _ from "lodash";
import {InstitutionService} from "../institution.service";
import "./institution-selector.less";
import {ILogService} from "angular";

class InstitutionSelectorController {

    private id: string;
    private loading: boolean;
    private ngRequired: boolean;

    /* @ngInject */
    constructor(private $log: ILogService,
                private institutionService: InstitutionService) {
    }

    public $onInit() {
        this.id = "institution-" + _.random(0, 9999);
    }

    public $onChange(changesObj) {
        this.$log.debug("changesObj.ngRequired", changesObj.ngRequired);
        this.ngRequired = (typeof changesObj.ngRequired !== "undefined") ? changesObj.ngRequired : true;
    }

    public searchInstitutions(query) {
        return this.institutionService.search(query);
    }

}

export const InstitutionSelectorComponent: angular.IComponentOptions = {
    bindings: {
        ngDisabled: "=",
        class: "@",
        ngModel: "=",
        ngRequired: "<?",
        showErrors: "<"
    },
    controller: InstitutionSelectorController,
    template: require("./institution-selector.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/institution/selector/institution-selector.component.ts